import React from "react";
import AddStudent from "../pages/createStudent";
import AddBatch from "../pages/create-batches";
import AddTeacher from "../pages/create-teacher";
import AddSubject from "../pages/create-subjects";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import AddAdmin from "../pages/create-admin";
import AbsenceNotification from "../pages/AbsenceNotification"; 

export default function AdminsDashboard(props) {
  const breadcrumbItems = [
    { label: "Apps", href: "/" },
    { label: "Teachers", href: "/teachers" },
    { label: "Students", href: "/students-data" },
    { label: "Batches", href: "/batches" },
    { label: "Subjects", href: "/subjects" },
    { label: "Attendance Dashboard", href: "/attendance-data" },
  ];

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-none d-md-block">
          <Breadcrumb className="py-2">
            {breadcrumbItems.map((item, index) => (
              <Breadcrumb.Item key={index} href={item.href}>
                {item.label}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
        <div className="ms-auto">
          <AbsenceNotification />
        </div>
      </div>

      <div className="d-md-none mb-4 mt-3">
        {" "}
        <Dropdown className="w-100">
          <Dropdown.Toggle
            variant="outline-secondary"
            className="w-100 text-start"
          >
            Quick Navigation
          </Dropdown.Toggle>
          <Dropdown.Menu className="w-100">
            {breadcrumbItems.map((item, index) => (
              <Dropdown.Item key={index} href={item.href}>
                {item.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="card p-3 mb-4 shadow-sm">
        <Row>
          <Col xs={12} md={6}>
            <div className="mb-4">
              <AddAdmin />
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="mb-4">
              <AddTeacher />
            </div>
          </Col>
        </Row>
      </div>

      <div className="card p-3 mb-4 shadow-sm">
        <Row>
          <Col xs={12} md={6}>
            <div className="mb-4">
            <AddStudent batches1={props.batches1} />
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div className="mb-4">
              <AddSubject />
            </div>
            <div className="mb-4">
              <AddBatch />
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
